import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';
import { browserHistory } from 'react-router';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import { findByUID, findById } from '../../../core/utils';
import {
  fetchHotels,
  fetchHotel,
  fetchHotelsSearch,
  fetchSuggestedHotels,
  fetchWaitlist,
  patchHotel,
  postHotelFeatures,
  postHotelClaim,
  postWaitlist,
  postHotelAddContact,
  postHotelRemoveContact,
  uploadHotelImage,
  deleteHotelPhoto,
  patchPhoto,
  postPhotoSort,
  postPropertyAccount,
} from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const HOTEL_ACCESS_FAILURE = 'HOTEL_ACCESS_FAILURE';
export const HOTEL_ACCESS_REQUEST = 'HOTEL_ACCESS_REQUEST';
export const HOTEL_ACCESS_SUCCESS = 'HOTEL_ACCESS_SUCCESS';
export const HOTEL_CONTACT_ADD_FAILURE = 'HOTEL_CONTACT_ADD_FAILURE';
export const HOTEL_CONTACT_ADD_REQUEST = 'HOTEL_CONTACT_ADD_REQUEST';
export const HOTEL_CONTACT_ADD_SUCCESS = 'HOTEL_CONTACT_ADD_SUCCESS';
export const HOTEL_CONTACT_REMOVE_FAILURE = 'HOTEL_CONTACT_REMOVE_FAILURE';
export const HOTEL_CONTACT_REMOVE_REQUEST = 'HOTEL_CONTACT_REMOVE_REQUEST';
export const HOTEL_CONTACT_REMOVE_SUCCESS = 'HOTEL_CONTACT_REMOVE_SUCCESS';
export const HOTEL_FETCH_FAILURE = 'HOTEL_FETCH_FAILURE';
export const HOTEL_FETCH_REQUEST = 'HOTEL_FETCH_REQUEST';
export const HOTEL_FETCH_SUCCESS = 'HOTEL_FETCH_SUCCESS';
export const HOTELS_FETCH_FAILURE = 'HOTELS_FETCH_FAILURE';
export const HOTELS_FETCH_REQUEST = 'HOTELS_FETCH_REQUEST';
export const HOTELS_FETCH_SUCCESS = 'HOTELS_FETCH_SUCCESS';
export const HOTEL_SUGGESTED_FETCH_FAILURE = 'HOTEL_SUGGESTED_FETCH_FAILURE';
export const HOTEL_SUGGESTED_FETCH_REQUEST = 'HOTEL_SUGGESTED_FETCH_REQUEST';
export const HOTEL_SUGGESTED_FETCH_SUCCESS = 'HOTEL_SUGGESTED_FETCH_SUCCESS';
export const HOTEL_CLAIM_FAILURE = 'HOTEL_CLAIM_FAILURE';
export const HOTEL_CLAIM_REQUEST = 'HOTEL_CLAIM_REQUEST';
export const HOTEL_CLAIM_SUCCESS = 'HOTEL_CLAIM_SUCCESS';
export const HOTEL_EDIT_FAILURE = 'HOTEL_EDIT_FAILURE';
export const HOTEL_EDIT_REQUEST = 'HOTEL_EDIT_REQUEST';
export const HOTEL_EDIT_SUCCESS = 'HOTEL_EDIT_SUCCESS';
export const HOTEL_EDIT_FEATURES_FAILURE = 'HOTEL_EDIT_FEATURES_FAILURE';
export const HOTEL_EDIT_FEATURES_REQUEST = 'HOTEL_EDIT_FEATURES_REQUEST';
export const HOTEL_EDIT_FEATURES_SUCCESS = 'HOTEL_EDIT_FEATURES_SUCCESS';
export const HOTEL_PHOTO_ADD_FAILURE = 'HOTEL_PHOTO_ADD_FAILURE';
export const HOTEL_PHOTO_ADD_REQUEST = 'HOTEL_PHOTO_ADD_REQUEST';
export const HOTEL_PHOTO_ADD_SUCCESS = 'HOTEL_PHOTO_ADD_SUCCESS';
export const HOTEL_PHOTO_REMOVE_FAILURE = 'HOTEL_PHOTO_REMOVE_FAILURE';
export const HOTEL_PHOTO_REMOVE_REQUEST = 'HOTEL_PHOTO_REMOVE_REQUEST';
export const HOTEL_PHOTO_REMOVE_SUCCESS = 'HOTEL_PHOTO_REMOVE_SUCCESS';
export const HOTEL_PHOTO_EDIT_FAILURE = 'HOTEL_PHOTO_EDIT_FAILURE';
export const HOTEL_PHOTO_EDIT_REQUEST = 'HOTEL_PHOTO_EDIT_REQUEST';
export const HOTEL_PHOTO_EDIT_SUCCESS = 'HOTEL_PHOTO_EDIT_SUCCESS';
export const HOTEL_PHOTO_SORT_FAILURE = 'HOTEL_PHOTO_SORT_FAILURE';
export const HOTEL_PHOTO_SORT_REQUEST = 'HOTEL_PHOTO_SORT_REQUEST';
export const HOTEL_PHOTO_SORT_SUCCESS = 'HOTEL_PHOTO_SORT_SUCCESS';
export const PROPERTY_ACCOUNT_REGISTER_FAILURE = 'PROPERTY_ACCOUNT_REGISTER_FAILURE';
export const PROPERTY_ACCOUNT_REGISTER_REQUEST = 'PROPERTY_ACCOUNT_REGISTER_REQUEST';
export const PROPERTY_ACCOUNT_REGISTER_SUCCESS = 'PROPERTY_ACCOUNT_REGISTER_SUCCESS';

export const HOTEL_SEARCH_FAILURE = 'HOTEL_SEARCH_FAILURE';
export const HOTEL_SEARCH_REQUEST = 'HOTEL_SEARCH_REQUEST';
export const HOTEL_SEARCH_SUCCESS = 'HOTEL_SEARCH_SUCCESS';
// ------------------------------------
// Actions
// ------------------------------------
export function viewBrowseHotel(id) {
  browserHistory.push(`/browse/hotels/${id}`);
}
export function viewHotel(id) {
  browserHistory.push(`/hotels/${id}`);
}

export function hotelAccessRequest() {
  return {
    type: HOTEL_ACCESS_REQUEST,
    payload: null,
  };
}
export function hotelAccessSuccess(json) {
  return {
    type: HOTEL_ACCESS_SUCCESS,
    payload: json.onlist,
  };
}
export function hotelAccessFailure(json) {
  return {
    type: HOTEL_ACCESS_FAILURE,
    payload: json,
  };
}
export function hotelFetchRequest() {
  return {
    type: HOTEL_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelFetchSuccess(json) {
  return {
    type: HOTEL_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelFetchFailure(json) {
  return {
    type: HOTEL_FETCH_FAILURE,
    payload: json,
  };
}
export function hotelsFetchRequest() {
  return {
    type: HOTELS_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelsFetchSuccess(json) {
  return {
    type: HOTELS_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelsFetchFailure(json) {
  return {
    type: HOTELS_FETCH_FAILURE,
    payload: json,
  };
}
export function hotelSuggestedFetchRequest() {
  return {
    type: HOTEL_SUGGESTED_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelSuggestedFetchSuccess(json) {
  return {
    type: HOTEL_SUGGESTED_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelSuggestedFetchFailure(json) {
  return {
    type: HOTEL_SUGGESTED_FETCH_FAILURE,
    payload: json,
  };
}
export function hotelClaimRequest() {
  return {
    type: HOTEL_CLAIM_REQUEST,
    payload: null,
  };
}
export function hotelClaimSuccess(json) {
  return {
    type: HOTEL_CLAIM_SUCCESS,
    payload: json,
  };
}
export function hotelClaimFailure(json) {
  return {
    type: HOTEL_CLAIM_FAILURE,
    payload: json,
  };
}

export function hotelEditRequest() {
  return {
    type: HOTEL_EDIT_REQUEST,
    payload: null,
  };
}
export function hotelEditSuccess(json) {
  return {
    type: HOTEL_EDIT_SUCCESS,
    payload: json,
  };
}
export function hotelEditFailure(json) {
  return {
    type: HOTEL_EDIT_FAILURE,
    payload: json,
  };
}
export function hotelEditFeaturesRequest(json) {
  return {
    type: HOTEL_EDIT_FEATURES_REQUEST,
    payload: json,
  };
}
export function hotelContactAddRequest(json) {
  return {
    type: HOTEL_CONTACT_ADD_REQUEST,
    payload: json,
  };
}
export function hotelContactAddFailure(json) {
  return {
    type: HOTEL_CONTACT_ADD_FAILURE,
    payload: json,
  };
}
export function hotelContactAddSuccess(json) {
  return {
    type: HOTEL_CONTACT_ADD_SUCCESS,
    payload: json,
  };
}
export function hotelContactRemoveRequest(json) {
  return {
    type: HOTEL_CONTACT_REMOVE_REQUEST,
    payload: json,
  };
}
export function hotelContactRemoveFailure(json) {
  return {
    type: HOTEL_CONTACT_REMOVE_FAILURE,
    payload: json,
  };
}
export function hotelContactRemoveSuccess(json) {
  return {
    type: HOTEL_CONTACT_REMOVE_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoAddRequest(json) {
  return {
    type: HOTEL_PHOTO_ADD_REQUEST,
    payload: json,
  };
}
export function hotelPhotoAddFailure(json) {
  return {
    type: HOTEL_PHOTO_ADD_FAILURE,
    payload: json,
  };
}
export function hotelPhotoAddSuccess(json) {
  return {
    type: HOTEL_PHOTO_ADD_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoRemoveRequest(json) {
  return {
    type: HOTEL_PHOTO_REMOVE_REQUEST,
    payload: json,
  };
}
export function hotelPhotoRemoveFailure(json) {
  return {
    type: HOTEL_PHOTO_REMOVE_FAILURE,
    payload: json,
  };
}
export function hotelPhotoRemoveSuccess(json) {
  return {
    type: HOTEL_PHOTO_REMOVE_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoEditRequest(json) {
  return {
    type: HOTEL_PHOTO_EDIT_REQUEST,
    payload: json,
  };
}
export function hotelPhotoEditFailure(json) {
  return {
    type: HOTEL_PHOTO_EDIT_FAILURE,
    payload: json,
  };
}
export function hotelPhotoEditSuccess(json) {
  return {
    type: HOTEL_PHOTO_EDIT_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoSortRequest(json) {
  return {
    type: HOTEL_PHOTO_SORT_REQUEST,
    payload: json,
  };
}
export function hotelPhotoSortFailure(json) {
  return {
    type: HOTEL_PHOTO_SORT_FAILURE,
    payload: json,
  };
}
export function hotelPhotoSortSuccess(json) {
  return {
    type: HOTEL_PHOTO_SORT_SUCCESS,
    payload: json,
  };
}
export function hotelSearchRequest() {
  return {
    type: HOTEL_SEARCH_REQUEST,
    payload: null,
  };
}
export function hotelSearchSuccess(json) {
  return {
    type: HOTEL_SEARCH_SUCCESS,
    payload: json,
  };
}
export function hotelSearchFailure(json) {
  return {
    type: HOTEL_SEARCH_FAILURE,
    payload: json,
  };
}
export function propertyAccountRegisterRequest() {
  return {
    type: PROPERTY_ACCOUNT_REGISTER_REQUEST,
    payload: null,
  };
}
export function propertyAccountRegisterSuccess() {
  return {
    type: PROPERTY_ACCOUNT_REGISTER_SUCCESS,
    payload: null,
  };
}
export function propertyAccountRegisterFailure(json) {
  return {
    type: PROPERTY_ACCOUNT_REGISTER_FAILURE,
    payload: json,
  };
}
export function checkWaitlist() {
  return dispatch => {
    dispatch(hotelAccessRequest());
    return fetchWaitlist()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelAccessSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAccessFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(checkWaitlist()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(checkWaitlist()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAccessFailure({}));
      });
  };
}

export function joinWaitlist() {
  return dispatch => {
    dispatch(hotelAccessRequest());
    return postWaitlist({})
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelAccessSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAccessFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(joinWaitlist()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(joinWaitlist()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAccessFailure({}));
      });
  };
}
export function registerPropertyAccount(payload) {
  return dispatch => {
    dispatch(propertyAccountRegisterRequest());
    return postPropertyAccount(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(propertyAccountRegisterSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(propertyAccountRegisterFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(joinWaitlist()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(joinWaitlist()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(propertyAccountRegisterFailure({}));
      });
  };
}

export function requestHotelSearch(payload) {
  return dispatch => {
    dispatch(hotelSearchRequest(payload));
    return fetchHotelsSearch(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelSearchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelSearchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotelSearch(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelSearch(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelSearchFailure(payload));
      });
  };
}
export function requestHotelClaim(id, payload) {
  return dispatch => {
    dispatch(hotelClaimRequest(id));
    return postHotelClaim(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'You are ready to manage your hotel',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelClaimSuccess(response));
        dispatch(push(`/hotels/${id}`));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelClaimFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotelClaim(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelClaim(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelClaimFailure(payload));
      });
  };
}
export function editHotel(id, payload) {
  return dispatch => {
    dispatch(hotelEditRequest(id));
    return patchHotel(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Hotel updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotel(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelEditFailure(payload));
      });
  };
}
export function editHotelFeatures(id, payload) {
  return dispatch => {
    dispatch(hotelEditFeaturesRequest(id));
    return postHotelFeatures(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Hotel Amenities Updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotel(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelEditFailure(payload));
      });
  };
}
export function addHotelContact(id, payload) {
  return dispatch => {
    dispatch(hotelContactRemoveRequest(payload));
    return postHotelAddContact(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Hotel contact added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelContactAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelContactAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelContact(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotelContact(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelContactAddFailure(payload));
      });
  };
}
export function removeHotelContact(id, payload) {
  return dispatch => {
    dispatch(hotelContactRemoveRequest(payload));
    return postHotelRemoveContact(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Contact',
          message: 'Hotel contact removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelContactRemoveSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelContactRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelContact(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelContact(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelContactRemoveFailure(payload));
      });
  };
}
export function addHotelPhoto(payload) {
  return dispatch => {
    dispatch(hotelPhotoAddRequest(payload));
    return uploadHotelImage(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'New photo added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelPhotoAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}
export function removeHotelPhoto(id, payload) {
  return dispatch => {
    dispatch(hotelPhotoRemoveRequest(payload));
    return deleteHotelPhoto(id)
      .then(checkHttpStatus)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Photo removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelPhotoRemoveSuccess({ id, response }));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}
export function editHotelPhoto(id, payload) {
  return dispatch => {
    dispatch(hotelPhotoEditRequest(payload));
    return patchPhoto(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelPhotoEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotelPhoto(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotelPhoto(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoEditFailure(payload));
      });
  };
}
export function sortHotelPhotos(id, payload) {
  return dispatch => {
    dispatch(hotelPhotoSortRequest(payload));
    return postPhotoSort(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelPhotoSortSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoSortFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(sortHotelPhotos(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(sortHotelPhotos(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoSortFailure(payload));
      });
  };
}

export function requestHotel(id) {
  return dispatch => {
    dispatch(hotelFetchRequest());
    return fetchHotel(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotel(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotel(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelFetchFailure());
      });
  };
}
export function requestHotels() {
  return dispatch => {
    dispatch(hotelsFetchRequest());
    return fetchHotels()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelsFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
              dispatch(hotelsFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotels()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotels()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelsFetchFailure());
      });
  };
}

export function requestSuggestedHotels() {
  return dispatch => {
    dispatch(hotelSuggestedFetchRequest());
    return fetchSuggestedHotels()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelSuggestedFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelSuggestedFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotels()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotels()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelSuggestedFetchFailure());
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [HOTEL_ACCESS_REQUEST]: (state, action) => {
    return update(state, {
      waitlist: {
        $merge: {
          needFetch: false,
          isFetching: true,
        },
      },
    });
  },
  [HOTEL_ACCESS_SUCCESS]: (state, action) => {
    return update(state, {
      waitlist: {
        $merge: {
          needFetch: false,
          isFetching: false,
          onWaitlist: action.payload,
        },
      },
    });
  },

  [HOTEL_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      selectedHotel: {
        $merge: {
          needFetch: false,
          isFetching: true,
        },
      },
    });
  },
  [HOTEL_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload,
        },
      },
    });
  },
  [HOTELS_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      $merge: {
        needFetch: false,
        isFetching: true,
      },
    });
  },
  [HOTELS_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        isFetching: false,
        hotels: action.payload.results,
      },
    });
  },
  [HOTEL_SUGGESTED_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      suggested: {
        $merge: {
          needFetch: false,
          isFetching: true,
        },
      },
    });
  },
  [HOTEL_SUGGESTED_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      suggested: {
        $merge: {
          isFetching: false,
          hotels: action.payload.results,
        },
      },
    });
  },
  [HOTEL_SEARCH_REQUEST]: (state, action) => {
    return update(state, {
      search: {
        $merge: {
          needFetch: false,
          isFetching: true,
          hotels: [],
        },
      },
    });
  },
  [HOTEL_SEARCH_SUCCESS]: (state, action) => {
    return update(state, {
      search: {
        $merge: {
          isFetching: false,
          hotels: action.payload.results,
        },
      },
    });
  },
  [HOTEL_CLAIM_SUCCESS]: (state, action) => {
    const id = action.payload.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);

    const suggested = state.suggested.hotels;
    const idx2 = suggested.findIndex(findByUID, id);

    let newState;
    // update the hotel lists
    if (idx === -1) {
      newState = update(state, {
        hotels: { $push: [action.payload] },
        suggested: {
          hotels: { $set: [...suggested.slice(0, idx2), ...suggested.slice(idx2 + 1)] },
        },
      });
    } else {
      newState = update(state, {
        hotels: {
          [idx]: { $set: action.payload },
        },
        suggested: {
          hotels: { $set: [...suggested.slice(0, idx2), ...suggested.slice(idx2 + 1)] },
        },
      });
    }
    return newState;
  },
  [HOTEL_CONTACT_ADD_SUCCESS]: (state, action) => {
    const id = action.payload.hotel.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload.hotel] },
        selectedHotel: {
          $merge: {
            isFetching: false,
            hotel: action.payload.hotel,
          },
        },
      });
    }
    return update(state, {
      hotels: { [idx]: { $set: action.payload.hotel } },
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload.hotel,
        },
      },
    });
  },
  [HOTEL_CONTACT_REMOVE_SUCCESS]: (state, action) => {
    const id = action.payload.hotel.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload.hotel] },
        selectedHotel: {
          $merge: {
            isFetching: false,
            hotel: action.payload.hotel,
          },
        },
      });
    }
    return update(state, {
      hotels: {
        [idx]: { $set: action.payload.hotel },
      },
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload.hotel,
        },
      },
    });
  },
  [HOTEL_PHOTO_REMOVE_SUCCESS]: (state, action) => {
    const id = action.payload.id;

    const photos = state.selectedHotel.hotel.photos;
    const idx2 = photos.findIndex(findById, id);
    if (idx2 === -1) {
      return state;
    }
    return update(state, {
      selectedHotel: {
        hotel: { photos: { $set: [...photos.slice(0, idx2), ...photos.slice(idx2 + 1)] } },
      },
    });
  },
  [HOTEL_PHOTO_ADD_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const photos = state.selectedHotel.hotel.photos;
    const idx = photos.findIndex(findById, id);
    if (idx === -1) {
      return update(state, {
        selectedHotel: {
          hotel: { photos: { $push: [action.payload] } },
        },
      });
    }
    return update(state, {
      selectedHotel: {
        hotel: { photos: { [idx]: { $set: action.payload } } },
      },
    });
  },
  [HOTEL_PHOTO_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const photos = state.selectedHotel.hotel.photos;
    const idx = photos.findIndex(findById, id);
    if (idx === -1) {
      return update(state, {
        selectedHotel: {
          hotel: { photos: { $push: [action.payload] } },
        },
      });
    }
    return update(state, {
      selectedHotel: {
        hotel: { photos: { [idx]: { $set: action.payload } } },
      },
    });
  },
  [HOTEL_PHOTO_SORT_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        hotel: { $merge: action.payload },
      },
    });
  },
  [HOTEL_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload] },
        selectedHotel: {
          $merge: {
            isFetching: false,
            hotel: action.payload,
          },
        },
      });
    }
    return update(state, {
      hotels: {
        [idx]: { $set: action.payload },
      },
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload,
        },
      },
    });
  },
  [PROPERTY_ACCOUNT_REGISTER_SUCCESS]: (state, action) => {
    return update(state, {
      register: {
        registered: { $set: true },
      },
    });
  },
  [PROPERTY_ACCOUNT_REGISTER_FAILURE]: (state, action) => {
    return update(state, {
      register: {
        message: { $set: action.payload.message },
      },
    });
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  hasError: false,
  hotels: [],
  waitlist: {
    needFetch: true,
    isFetching: false,
    onWaitlist: false,
  },
  selectedHotel: {
    isFetching: false,
    needFetch: true,
    hasError: false,
    hotel: {},
  },
  suggested: {
    isFetching: false,
    needFetch: true,
    hasError: false,
    hotels: [],
  },
  search: {
    isFetching: false,
    needFetch: false,
    hasError: false,
    hotels: [],
  },
  register: {
    message: null,
    isFetching: false,
    registered: false,
  },
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/hotels/modules/hotels.js